var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "my-plan-container" }, [
    _c(
      "div",
      { staticClass: "title-1", staticStyle: { margin: "12px 0 0 0" } },
      [_vm._v(_vm._s(_vm.planData.title))]
    ),
    _c(
      "div",
      { staticClass: "plan-grid flex-between" },
      _vm._l(_vm.chartData, function (item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "plan-item flex-between",
            on: {
              click: [
                function ($event) {
                  return _vm.handleClick(item)
                },
                function ($event) {
                  $event.stopPropagation()
                  return _vm.goDetail(item.path)
                },
              ],
            },
          },
          [
            _c("div", { staticClass: "plan-content" }, [
              _c("div", { staticClass: "plan-name" }, [
                _vm._v(_vm._s(item.name)),
              ]),
              _c("div", { staticClass: "plan-count" }, [
                _vm._v(_vm._s(item.value)),
              ]),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: item.path,
                    expression: "item.path",
                  },
                ],
                staticClass: "right-icon flex-center",
              },
              [
                _c("a-icon", {
                  staticStyle: { "font-size": "14px", color: "#fff" },
                  attrs: { type: "right" },
                }),
              ],
              1
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }